import React from 'react';
import { Icon } from 'Components';
import i18n from 'i18next';
import './NoResultsFound.css';

const NoResultsFound = () => (
  <div className="no-results-found">
    <hr className="no-results-found__hr" />
    <h1 className="no-results-found__h1">
      {i18n.t('globalSearch:reviseYourFilter')}
    </h1>
    <h2 className="no-results-found__h2">
      {i18n.t('globalSearch:noInfoFoundOnSearch')}
    </h2>
    <Icon icon="find_in_page" />
  </div>
);

export default NoResultsFound;



// WEBPACK FOOTER //
// ./src/components/NoResultsFound/NoResultsFound.jsx